import { useEffect } from 'react'

import { usePostNotesContext } from './PostNotesProvider'

/**
 * Deleting the last Note removes the element that held focus, so focus has to
 * land somewhere deliberate. Mounted inside a `PostNotesProvider`, this waits
 * for the feed to settle empty after a confirmed delete and then hands focus
 * to the surface's fallback target.
 *
 * The request flag lives in the surface rather than here because
 * `PostNotesProvider` takes `focusAfterDelete` as a prop, so the surface is
 * the only component that sits above both.
 */
export function FocusAfterDelete({
  requested,
  onHandled,
  focusCreate,
}: {
  requested: boolean
  onHandled: () => void
  focusCreate: () => void
}): null {
  const { notes } = usePostNotesContext()
  useEffect(() => {
    if (
      !requested ||
      notes.status !== 'ready' ||
      notes.readBusy ||
      notes.notes.length !== 0
    )
      return
    queueMicrotask(() => {
      focusCreate()
      onHandled()
    })
  }, [requested, notes, onHandled, focusCreate])
  return null
}
